import { useEffect } from 'react';
import { type Spacing } from '#themes/stena-recycling';
import { setAppBackgroundColor } from '../AppContainer/setAppBackgroundColor';
import { PageContainerWrapper, PageContainerModalWrap } from './styles';

type PageContainerProps = {
  children: React.ReactNode;
  backgroundColor?: string;
  paddingTop?: Spacing;
  fullWidthMobile?: boolean;
};

export const PageContainer = ({
  backgroundColor,
  children,
  paddingTop,
  fullWidthMobile,
}: PageContainerProps) => {
  useEffect(() => {
    if (backgroundColor) {
      setAppBackgroundColor(backgroundColor);
    }
  }, [backgroundColor]);

  return (
    <PageContainerModalWrap>
      <PageContainerWrapper
        id="page-container"
        paddingTop={paddingTop}
        fullWidthMobile={fullWidthMobile}
      >
        {children}
      </PageContainerWrapper>
    </PageContainerModalWrap>
  );
};
